<p *ngIf="isExpired()" style="color: red;"><strong>Your credential(s) will be listed as expired. Are you sure you want to continue?</strong></p>
<form (ngSubmit)="onSubmit()">
	<fieldset>
		<legend>Send To Self</legend>
		<div class="data-item">
			<div class="data-item__label label">Send To:</div>
			<div class="data-item__value" *ngIf="address">
				<div>{{address.line1}}</div>
				<div *ngIf="address.line2">{{address.line2}}</div>
				<div *ngIf="address.line3">{{address.line3}}</div>
				<div>{{address.city}}, {{address.state}} {{address.postalCode}}</div>
			</div>
		</div>
		<p>If this is incorrect, <a routerLink="/practitioner/profile/edit">click here</a> to edit your profile and update your address.</p>

		<div class="form-actions form-actions--multi-step">
			<input class="button form-actions__item form-actions__item--continue" type="submit" value="Continue" />
			<button (click)="onBack($event)" class="button button--secondary form-actions__item form-actions__item--back">Back</button>
		</div>
	</fieldset>
</form>